// noinspection DuplicatedCode

import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API
export const getSpecPelatihan = createAsyncThunk(
    "claimPengobatanTransaksi/getSpecPelatihan",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getSpecPelatihan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getPelatihanTransaksi = createAsyncThunk(
    "pelatihanTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getPelatihan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertPelatihanTransaksi = createAsyncThunk(
    "pelatihanTransaksi/insert",
    async (
        {
            Nik,
            TopikPelatihan,
            JenisPelatihan,
            LembagaPelatihan,
            MateriPelatihan,
            TujuanPelatihan,
            TanggalPelaksanaan,
            TanggalSelesai,
            TempatPelaksanaan,
            BiayaPelatihan,
            Tiket,
        },
        thunkAPI
    ) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("TopikPelatihan", TopikPelatihan);
        formData.append("JenisPelatihan", JenisPelatihan);
        formData.append("LembagaPelatihan", LembagaPelatihan);
        formData.append("MateriPelatihan", MateriPelatihan);
        formData.append("TujuanPelatihan", TujuanPelatihan);
        formData.append("TanggalPelaksanaan", TanggalPelaksanaan);
        formData.append("TanggalSelesai", TanggalSelesai);
        formData.append("TempatPelaksanaan", TempatPelaksanaan);
        formData.append("BiayaPelatihan", BiayaPelatihan);
        formData.append("Tiket", Tiket);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertPelatihan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updatePelatihanTransaksi = createAsyncThunk(
    "pelatihanTransaksi/update",
    async (
        {
            TPelatihanID,
            Nik,
            TopikPelatihan,
            JenisPelatihan,
            LembagaPelatihan,
            MateriPelatihan,
            TujuanPelatihan,
            TanggalPelaksanaan,
            TanggalSelesai,
            TempatPelaksanaan,
            BiayaPelatihan,
            Tiket,
        },
        thunkAPI
    ) => {
        let formData = new FormData();
        formData.append("TPelatihanID", TPelatihanID);
        formData.append("Nik", Nik);
        formData.append("TopikPelatihan", TopikPelatihan);
        formData.append("JenisPelatihan", JenisPelatihan);
        formData.append("LembagaPelatihan", LembagaPelatihan);
        formData.append("MateriPelatihan", MateriPelatihan);
        formData.append("TujuanPelatihan", TujuanPelatihan);
        formData.append("TanggalPelaksanaan", TanggalPelaksanaan);
        formData.append("TanggalSelesai", TanggalSelesai);
        formData.append("TempatPelaksanaan", TempatPelaksanaan);
        formData.append("BiayaPelatihan", BiayaPelatihan);
        formData.append("Tiket", Tiket);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updatePelatihan",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getPelatihanLaporan = createAsyncThunk(
    "getPelatihanLaporan/post",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/pelatihan/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetPelatihanSlice = createAsyncThunk(
    "resetPelatihanSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecPelatihanData: [],
    isSpecPelatihanFetching: false,
    isSpecPelatihanSuccess: false,
    isSpecPelatihanError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false
};

//SLICES
export const pelatihanTransaksiSlice = createSlice({
    name: "pelatihanTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getSpecPelatihan.fulfilled]: (state, {payload}) => {
            state.SpecPelatihanData = payload.data[0];
            state.isSpecPelatihanSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecPelatihan.rejected]: (state, {payload}) => {
            state.isSpecPelatihanFetching = false;
        },
        [getSpecPelatihan.pending]: (state) => {
            state.isSpecPelatihanFetching = false;
        },

        [getPelatihanLaporan.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.message = payload.message;
            state.isGetReport = true;
            return state;
        },
        [getPelatihanLaporan.rejected]: (state, {payload}) => {
            state.isSpecPelatihanFetching = false;
        },
        [getPelatihanLaporan.pending]: (state) => {
            state.isSpecPelatihanFetching = false;
        },

        [getPelatihanTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getPelatihanTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getPelatihanTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertPelatihanTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertPelatihanTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertPelatihanTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updatePelatihanTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updatePelatihanTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updatePelatihanTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const pelatihanTransaksiSelector = (state) => state.pelatihanTransaksi;
